<template>
    <v-tabs
        :slider-color="'#E4183E'"
        show-arrows
        class="shop-gallery__big-img"
    >
        <v-tab v-for="(item, id) in images" :key="id" :style="{background: 'url(' + item + ') 50% 50% / 90px 90px no-repeat '}"
               class="shop-gallery" @click="changeImage(item)"
        />
    </v-tabs>
</template>

<script>
export default {
  props: ['images', 'changeImage'],
};
</script>

<style scoped lang="sass">
.shop-gallery
  min-width: 194px !important
  height: 100px
  margin: 0 10px
  &__big-img
      max-width: 621px
      width: 100%
</style>
